import { Card, Col, Flex, Title } from '@tremor/react';
import { FC } from 'react';
import { OutlinedLink } from '../../Links/OutlinedLink/OutlinedLink';
import { AddColorIcon } from '@/assets';
import { connectorsWithPngIcons } from '@/utils/constants';

interface Props {
  name: string;
  connectorName: string;
  isAdded: boolean;
}

export const ConnectorListTile: FC<Props> = ({ connectorName, name, isAdded }) => {
  return (
    <Col
      className={[
        'gap-5 mt-5',
        isAdded ? '!select-none pointer-events-none grayscale hover:cursor-auto' : '',
      ].join(' ')}
    >
      <Card className="hover:shadow-lg transition-all duration-200 rounded-xl">
        <Flex justifyContent="start">
          <img
            className="h-[24px] w-[24px]"
            src={`/connectors/${connectorName}.${
              connectorsWithPngIcons.includes(connectorName) ? 'png' : 'svg'
            }`}
            alt={`${connectorName} icon`}
          />
          <Title className="ml-[10px] text-[24px] leading-[36px] font-bold capitalize text-secondary-500-base font-inter">
            {name}
          </Title>
        </Flex>
        <OutlinedLink
          className="ml-auto !rounded-xl w-fit mt-8"
          to={{ pathname: `../info/${connectorName}` }}
          relative="path"
        >
          {isAdded ? (
            'Already Added'
          ) : (
            <>
              Add <img src={AddColorIcon} alt="add connector button icon" />
            </>
          )}
        </OutlinedLink>
      </Card>
    </Col>
  );
};
